import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import axios from 'axios'
const firebaseConfig = {
    apiKey: process.env.VUE_APP_PUSH_APIKEY,
    authDomain: process.env.VUE_APP_PUSH_DOMAIN,
    projectId: process.env.VUE_APP_PUSH_PID,
    storageBucket: process.env.VUE_APP_PUSH_BUCKET,
    messagingSenderId: process.env.VUE_APP_PUSH_SENDER,
    appId: process.env.VUE_APP_PUSH_APPID
};
let app = initializeApp(firebaseConfig);

class PushService {

  async getToken() {
      let result = null;

      // Initialize Firebase
      const permission = await Notification.requestPermission();
      
      if (permission !== 'granted') {
        // TODO: Добавить уведомление в store
          console.log("user denied notifications")
      } else {
        const messaging = await getMessaging(app);
        
        getToken(messaging, { vapidKey: process.env.VUE_APP_PUSH_VAPID })
          .then(token => {
            if (token) {
              result = token 
              axios.post('/api/account/push/add', {token})
              .catch(err => {
                console.log(err);
              })
            } else {
              // TODO: Добавить уведомление в store
              console.log('No registration token available. Request permission to generate one.');
            }
          })
      
      onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
      });
    }
    return result;
  }

  async deleteToken () {
    const messaging = await getMessaging(app);
    getToken(messaging, { vapidKey: process.env.VUE_APP_PUSH_VAPID })
      .then(token => {
        if (token) {
          axios.post('/api/account/push/delete', {token})
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  }
}
  
export default new PushService()